<template>
  <v-dialog v-model="dialog" width="600px" max-width="95vw" persistent>
    <v-card class="dialog-card">
      <v-card-title class="headline primary white--text">
        <v-icon left color="white">send</v-icon> 
        Re-enviar Permiso
      </v-card-title>
      
      <v-form
        @submit.prevent="enviarPermiso"
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-card-text class="pt-4">
          <v-alert type="warning" dense class="mb-4">
            <strong>¿Está seguro de re-enviar el permiso?</strong>
            <div class="mt-1">Nota: Ya no podrá realizar cambios después de enviar</div>
          </v-alert>

          <v-layout row wrap class="select-container">
            <v-flex xs12>
              <v-select
                class="text-field-reducido-border"
                :items="lista_funcionarios"
                item-value="id_persona"
                :item-text="formatearFuncionario"
                v-model="funcionarioSeleccionado"
                name="id_funcionario"
                label="Seleccione funcionario a enviar *"
                autofocus
                required
                outlined
                dense
                :rules="[v => !!v || 'El funcionario es requerido']"
                return-object
                :loading="loading"
                prepend-icon="person"
                :menu-props="{ maxHeight: 300, offsetY: true }"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-truncate">{{ formatearFuncionario(item) }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <div class="select-item-content">
                    <div class="list-item-title">{{ formatearFuncionario(item) }}</div>
                    
                    <div v-if="item.unidad" class="list-item-subtitle">{{ item.unidad }}</div>
                  </div>
                </template>
              </v-select>
            </v-flex>
          </v-layout>

          <!-- Información del permiso -->
          <v-expansion-panels flat v-if="permiso" class="mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <template v-slot:default="{ open }">
                  <v-row no-gutters>
                    <v-col cols="4">Información del Permiso</v-col>
                    <v-col cols="8" class="text--secondary">
                      <v-fade-transition leave-absolute>
                        <span v-if="open" key="0">
                          Click para contraer
                        </span>
                        <span v-else key="1">
                          {{ permiso.tipo_permiso }} - {{ permiso.numero }}
                        </span>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="info-list">
                  <div class="info-item">
                    <strong>Tipo:</strong> {{ permiso.tipo_permiso }}
                  </div>
                  <div class="info-item">
                    <strong>Número:</strong> {{ permiso.numero }}
                  </div>
                  <div class="info-item">
                    <strong>Fecha:</strong> {{ permiso.fecha_desde }} - {{ permiso.fecha_retorno }}
                  </div>
                  <div class="info-item">
                    <strong>Horas:</strong> {{ permiso.hora_desde }} - {{ permiso.hora_hasta }}
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            color="grey darken-1" 
            text 
            @click.prevent="close()"
            :disabled="loading"
          > 
            Cancelar 
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="!valid || !funcionarioSeleccionado"
            color="primary"
            @click="enviarPermiso()"
            depressed
          >
            <v-icon left>send</v-icon>
            Re-enviar Permiso
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],

  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      id: null,
      id_persona: null,
      rol: {},
      lista_funcionarios: [],
      funcionarioSeleccionado: null,
      valid: false,
      datos_usuario: null
    };
  },

  mounted() {
    this.$bus.$on("openDialogReenviarPermiso", async item => {
      this.id = item.permiso.id;
      this.permiso = item;
      this.datos_usuario = await this.obtieneDatosPersona(
        this.permiso.id_persona
      );
      this.dialog = true;
      this.cargarDatos();
    });
  },
  
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.funcionarioSeleccionado = null;
      this.datos_usuario = null;
      this.$bus.$emit("closeDialogReenviarPermiso");
    },

    async obtieneDatosPersona(id_persona) {
      try {
        let usuario = null;
        let respuesta = await this.$service.graphql({
          query: `
          query{
              runQuery(consulta:"select u.correo,u.nombre_usuario,up.id_persona,u.id as id_usuario,p.ap_paterno,p.ap_materno,p.nombres from seguridad.usuario_persona up join seguridad.usuario u  on up.id_usuario =u.id join persona.persona p on up.id_persona =p.id  where up.id_persona =  ${id_persona}"){
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
        if (respuesta.length > 0) {
          usuario = respuesta[0];
        }
        return usuario;
      } catch (error) {
        console.log(error);
      }
    },

    // Método para formatear la visualización del funcionario
    formatearFuncionario(funcionario) {
      if (!funcionario) return '';
      return `${funcionario.nombre || ''} - ${funcionario.item || ''}`.trim();
    },

    async cargarDatos() {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
          query: `
              query{
                vListaPersonals(id_estado:1, activo_pasivo:"1|Activo"){
                  rows{
                    id_persona
                    id_estado
                    nro_doc
                    nro_complemento
                    item
                    nombre
                    unidad
                    fecha_ingreso
                    cargo
                    id_cargo
                    id_puesto
                    id_item
                    id_unidad
                    id_movilidad
                    estado
                    fecha_pasivo
                    activo_pasivo
                  }
                }
              }
            `
        });
        
        // Ordenar por nombre
        this.lista_funcionarios = rpta.vListaPersonals.rows.sort((a, b) => {
          const nombreA = (a.nombre || '').toLowerCase();
          const nombreB = (b.nombre || '').toLowerCase();
          return nombreA.localeCompare(nombreB);
        });
        
        this.loading = false;
      } catch (error) {
        //console.log(error);
        this.loading = false;
      }
    },

    // Validar formulario antes de enviar
    validarFormulario() {
      if (this.$refs.form) {
        return this.$refs.form.validate();
      }
      return false;
    },

    async enviarPermiso() {
      let user = this.$storage.get("user");
      let id_persona = this.$route.params.id;
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));

      
      // Validar que se haya seleccionado un funcionario
      if (!this.funcionarioSeleccionado) {
        this.$confirm("Debe seleccionar un funcionario antes de enviar", () => {});
        return;
      }

      // Validar formulario completo
      if (!this.validarFormulario()) {
        this.$confirm("Por favor complete todos los campos requeridos", () => {});
        return;
      }

      this.loading = true;

      try {
        // Construir la consulta
        const query = `
          query {
            runQuery(consulta: "select control.fn_registra_aprueba_jefe_seguimiento(${this.permiso.id_permiso}, 6, ${this.datos_usuario.id_usuario}, ${this.permiso.id_persona}, ${this.funcionarioSeleccionado.id_persona})") {
              respuesta
            }
          }
        `;

        let respuesta = await this.$service.graphql({ query });
        
        // Verificar si la respuesta tiene la estructura esperada
        if (!respuesta || !respuesta.runQuery || !respuesta.runQuery.respuesta) {
          //console.error('Estructura de respuesta inválida:', respuesta);
          this.$confirm("Error en la respuesta del servidor", () => {});
          this.loading = false;
          return;
        }

        // Obtener el resultado de la función
        const resultado = respuesta.runQuery.respuesta[0];

        // Verificar si existe la propiedad de la función
        const funcionKey = Object.keys(resultado)[0];
        if (!funcionKey) {
          this.$confirm("Error al procesar la respuesta", () => {});
          this.loading = false;
          return;
        }

        const resultadoFuncion = resultado[funcionKey];

        // Procesar el resultado
        if (resultadoFuncion && typeof resultadoFuncion === 'string') {
          const resps2 = resultadoFuncion.split("|");
          //console.log('Resultado dividido:', resps2);
          
          const correcto = resps2[0] == "1";
          if (correcto) {
            this.$confirm("El permiso fue enviado exitosamente", () => {});
          } else {
            this.$confirm(resps2[1] || "Error al enviar el permiso", () => {});
          }
        } else {
          this.$confirm("Error inesperado al procesar el permiso", () => {});
        }

      } catch (error) {
        this.$confirm("Error al enviar el permiso: " + error.message, () => {});
      } finally {
        await this.enviarCorreoDestinatario(permiso_copia);
        this.loading = false;
        this.close();
      }
    },

    getUserId() {
      const user = this.$storage.get("user");
      return parseInt(user.id_persona);
    },

    async enviarCorreoDestinatario(permiso) {
      
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      
      if (!destinatario) {
        //console.log('No hay destinatarios!')
        return;
      }

      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: `NOTIFICACIÓN SOLICITUD DE PERMISO`,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
  }
};
</script>

<style scoped>
.dialog-card {
  border-radius: 8px;
  overflow: hidden;
}

.select-container {
  min-height: 80px;
}

/* Mejoras para el select */
.text-field-reducido-border {
  margin-bottom: 8px;
}

/* Personalización del menú del select */
.select-menu-custom {
  max-height: 300px !important;
  z-index: 1000;
}

/* Asegurar que el select tenga suficiente espacio */
.v-select__selection {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Estilos para los items del select */
.select-item-content {
  padding: 8px 16px;
  width: 100%;
}

.list-item-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.list-item-subtitle {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}

/* Estilos para la lista de información */
.info-list {
  padding: 8px 0;
}

.info-item {
  padding: 4px 0;
  font-size: 14px;
  line-height: 1.4;
}

/* Mejorar la visualización en dispositivos móviles */
@media (max-width: 600px) {
  .v-dialog {
    margin: 16px;
    width: calc(100% - 32px) !important;
    max-width: calc(100% - 32px) !important;
  }
  
  .v-card__actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .v-card__actions .v-btn {
    width: 100%;
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/ReenviarPermiso.vue